<template>
    <div id="CallInHistoryv2">
        <div class="Penaltitle">最近通話記錄</div>
        <div class="d-flex justify-content-between align-items-center">
            <div class="md-text">{{Today}}</div>
            <!--<div class="more">顯示全部</div>-->
        </div>
        <div class="CallInHistoryWrap" v-if="CallInHistory.item.length !== 0">
            <div class="CallInHistoryItem" v-for="(item,index) in CallInHistory.item" :key="index">
                <div class="position-relative d-flex align-items-center">
                    <div class="statusIcon d-flex align-items-center justify-content-center">
                        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="item.upAgent">
                            <path d="M0.024711 13.7239L0.074133 13.8631L0.0988439 13.9559L0.123555 14.0255L0.197683 14.0951L0.247105 14.1647L0.321238 14.2343C0.44479 14.42 0.61776 14.5824 0.815444 14.6984L0.938999 14.768L1.01313 14.8144L1.08726 14.884L1.16139 14.9072L1.23552 14.9304L1.33437 14.9536C1.45792 14.9768 1.55676 15 1.68031 15C1.70502 15 1.72973 15 1.75444 15H11.2927C12.2069 15 12.9483 14.3039 12.973 13.4455C12.973 13.3063 12.9236 13.1671 12.8741 13.0278C12.6764 12.3782 12.0587 11.8678 11.2927 11.8678L7.63552 11.8445C7.41313 11.8445 7.21544 11.7749 7.06718 11.6357C6.99305 11.5197 6.94363 11.4501 6.89421 11.3573C6.79537 11.0789 6.8695 10.7773 7.09189 10.5684L15.5181 2.65661C16.1606 2.05336 16.1606 1.05568 15.5181 0.452436C14.8757 -0.150812 13.8131 -0.150812 13.1707 0.452436L4.7444 8.36427C4.52201 8.57309 4.17606 8.64269 3.87954 8.52668C3.5583 8.41067 3.36062 8.13225 3.36062 7.83063V4.39675C3.36062 4.35035 3.36062 4.28074 3.36062 4.23434C3.3112 3.37587 2.52046 2.70302 1.60618 2.74942C0.691891 2.79582 -0.0247099 3.53828 0.024711 4.39675L0 12.9814V13.3759V13.4223C0 13.5383 0.024711 13.6311 0.024711 13.7239Z" fill="#58D786" />
                        </svg>
                        <svg width="21" height="13" viewBox="0 0 21 13" fill="none" xmlns="http://www.w3.org/2000/svg" v-else-if="!item.upAgent">
                            <path d="M20.5867 3.83255C20.0329 3.31132 19.1209 3.31132 18.5508 3.83255L12.2966 9.71934L6.05874 3.84788C5.8633 3.66392 5.79815 3.38797 5.91216 3.14269C6.00988 2.88208 6.27047 2.72877 6.56364 2.72877H9.69073C9.73959 2.72877 9.78845 2.72877 9.8536 2.72877C10.6517 2.68278 11.2543 2.05425 11.2054 1.30307C11.1566 0.551887 10.4725 -0.0153302 9.69073 0.0306604L1.43325 0H1.38439C1.30296 0 1.20523 0 1.1238 0.0153302L0.993503 0.0613208L0.928356 0.0919811L0.863208 0.107311L0.79806 0.153302L0.732912 0.183962L0.684052 0.245283C0.504895 0.337264 0.358313 0.475236 0.244304 0.643868L0.195443 0.751179L0.162869 0.8125L0.0977216 0.858491L0.0814346 0.935142L0.0651477 0.996462L0.0325739 1.07311C0.0162869 1.16509 0 1.25708 0 1.34906C0 1.36439 0 1.37972 0 1.41038V9.13679C0 9.88797 0.635191 10.4858 1.43325 10.4858C2.23131 10.4858 2.8665 9.88797 2.8665 9.13679L2.88279 6.17807C2.88279 6.00943 2.94794 5.8408 3.07823 5.71816C3.14338 5.67217 3.22481 5.62618 3.30625 5.59552C3.56684 5.51887 3.84372 5.58019 4.02288 5.76415C4.02288 5.76415 11.2706 12.5861 11.2869 12.6014C11.4497 12.7087 11.58 12.8314 11.7755 12.908C11.9546 12.9693 12.1501 13 12.3455 13C13.0621 12.9693 13.5507 12.3715 14.0231 11.9269C14.528 11.4517 15.0491 10.9611 15.554 10.4858C16.1892 9.88797 16.8081 9.30542 17.4433 8.70755C18.0296 8.15566 18.616 7.60377 19.2023 7.05189C19.5932 6.68396 19.9678 6.33137 20.3587 5.96344C20.4238 5.90212 20.5053 5.82547 20.5704 5.76415C21.1405 5.21226 21.1405 4.35377 20.5867 3.83255Z" fill="#FF574F" />
                        </svg>
                    </div>

                    <div style="margin-right: 5px;width: 110px;">
                        <div class="mb-1 gray-text">{{item.name == null ? '新客戶' : item.name == 0 ? '多筆重複資料' : item.name}}</div>
                        <div class="d-flex align-items-center">
                            <img  width="14" height="14" class="mr-2" src="../assets/GetPhoneIcon.png" />
                            <span style="font-size: 14px;color: #D0D2D9;width: 90px;display:inline-block">
                                {{item.fromPhoneNo}}
                            </span>

                        </div>
                    </div>
                    <div class="mr-3" style="width:40px;height:40px;">
                        <svg width="40" height="40" viewBox="0 0 30 30" fill="none" v-if="item.location == '諮詢室'" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="15" cy="15" r="14.5" stroke="#93959C" />
                            <path d="M14.1404 20H15.8596V13.0949H14.1404V20ZM15.0058 11.9852C15.5906 11.9852 16 11.5906 16 10.9864C16 10.3946 15.5906 10 15.0058 10C14.4094 10 14 10.3946 14 10.9864C14 11.5906 14.4094 11.9852 15.0058 11.9852Z" fill="#93959C" />
                        </svg>
                        <svg width="40" height="40" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" v-else-if="item.location == '櫃台'">
                            <circle cx="15" cy="15" r="14.5" stroke="#93959C" />
                            <path d="M14.3656 20.1665C13.7195 20.155 13.091 20.1036 12.4802 20.0122C11.8693 19.9094 11.3759 19.7723 11 19.601V18.1444C11.3994 18.3272 11.9104 18.4871 12.533 18.6242C13.1557 18.7613 13.7665 18.8356 14.3656 18.847V15.3856C13.2026 15.0771 12.351 14.6887 11.8106 14.2203C11.2702 13.7519 11 13.1122 11 12.3011C11 11.4557 11.2996 10.7931 11.8987 10.3133C12.5095 9.83354 13.3319 9.56508 14.3656 9.50796V8H15.4934V9.49082C16.116 9.50224 16.6799 9.57079 17.185 9.69645C17.7019 9.81069 18.1718 9.95349 18.5947 10.1248L18.1189 11.3929C17.743 11.2444 17.326 11.1187 16.8678 11.0159C16.4214 10.9017 15.9633 10.8274 15.4934 10.7931V14.2375C16.2687 14.4545 16.9148 14.6887 17.4317 14.94C17.9486 15.1799 18.3363 15.4827 18.5947 15.8482C18.8649 16.2024 19 16.665 19 17.2362C19 18.0359 18.6946 18.6871 18.0837 19.1897C17.4728 19.6809 16.6094 19.9837 15.4934 20.0979V22H14.3656V20.1665ZM14.3656 10.8274C13.7313 10.8731 13.2614 11.0159 12.9559 11.2558C12.6623 11.4957 12.5154 11.8042 12.5154 12.1812C12.5154 12.6381 12.6446 12.9922 12.9031 13.2436C13.1733 13.4835 13.6608 13.6891 14.3656 13.8605V10.8274ZM15.4934 18.7613C16.1865 18.6928 16.6916 18.5386 17.0088 18.2987C17.326 18.0473 17.4846 17.7275 17.4846 17.339C17.4846 16.9049 17.3436 16.5794 17.0617 16.3623C16.7797 16.1338 16.257 15.9282 15.4934 15.7454V18.7613Z" fill="#93959C" />
                        </svg>
                        <svg width="40" height="40" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" v-else-if="item.location == '員休室'">
                            <circle cx="15" cy="15" r="14.5" stroke="#93959C" />
                            <path d="M14.3333 10.8V12.2C13.5486 12.2 12.7812 12.4424 12.1267 12.897C11.4722 13.3516 10.9595 13.9983 10.6524 14.7565C10.3454 15.5148 10.2575 16.3511 10.3998 17.1615C10.542 17.9718 10.9082 18.7202 11.4526 19.3137C11.997 19.9071 12.6956 20.3193 13.4614 20.499C14.2273 20.6786 15.0265 20.6177 15.7597 20.324C16.4929 20.0302 17.1275 19.5164 17.5847 18.8467C18.0418 18.177 18.3012 17.3809 18.3307 16.5575L18.3333 16.4H19.6667C19.6667 17.8852 19.1048 19.3096 18.1046 20.3598C17.1044 21.41 15.7478 22 14.3333 22C12.9188 22 11.5623 21.41 10.5621 20.3598C9.5619 19.3096 9 17.8852 9 16.4C9 13.3655 11.3867 10.8 14.3333 10.8ZM21 8V9.4L17.4487 13.6H21V15H15.6667V13.6L19.2173 9.4H15.6667V8H21Z" fill="#93959C" />
                        </svg>
                        <svg width="40" height="40" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" v-else-if="item.location == '藥局'">
                            <circle cx="15" cy="15" r="14.5" stroke="#93959C" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7191 10.3563C15.4897 9.05932 17.1965 8.61493 18.5312 9.36376C19.8659 10.1126 20.3232 11.7711 19.5526 13.0681L15.6458 19.6437C14.8752 20.9407 13.1684 21.3851 11.8337 20.6362C10.499 19.8874 10.0417 18.2289 10.8123 16.9319L14.7191 10.3563ZM16.8646 16.1338L18.8973 12.7126C19.4675 11.753 19.1242 10.5314 18.1497 9.98464C17.1828 9.44219 15.9405 9.75906 15.3744 10.7118L13.3276 14.1568L16.8646 16.1338Z" fill="#93959C" />
                        </svg>
                        <svg width="40" height="40" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" v-else-if="item.location == '行銷部'">
                            <circle cx="15" cy="15" r="14.5" stroke="#93959C" />
                            <path d="M12.4272 16.9238L11.1952 12.326L19.2807 7.65278C19.8501 7.32364 20.5768 7.62443 20.747 8.25974L22.795 15.9029C22.9679 16.5482 22.4716 17.1784 21.8037 17.1614L12.4272 16.9238Z" stroke="#93959C" />
                            <path d="M13.802 22.0542L12.4272 16.9234L9.7951 17.6287L11.1699 22.7595L13.802 22.0542Z" stroke="#93959C" />
                            <path d="M7.96593 13.1911L11.1953 12.3258L12.4272 16.9236L9.19789 17.7889C8.66443 17.9318 8.11609 17.6153 7.97315 17.0818L7.25882 14.4159C7.11588 13.8824 7.43246 13.3341 7.96593 13.1911Z" stroke="#93959C" />
                        </svg>
                        <svg width="40" height="40" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" v-else-if="item.location == '客服'">
                            <circle cx="15" cy="15" r="14.5" stroke="#93959C" />
                            <path d="M19.6052 8.50595L19.6051 8.5059C18.4708 7.31164 16.9517 6.59756 15.3391 6.50928C13.7265 6.42098 12.1437 6.96541 10.8962 8.03085C9.64939 9.09565 8.82625 10.6044 8.57844 12.2629C8.33065 13.9213 8.67438 15.6193 9.54703 17.0305L9.54705 17.0305L13.7183 23.7743L13.7183 23.7743C13.8539 23.9935 14.0411 24.1764 14.2649 24.3042C14.489 24.4321 14.7416 24.5 14.9997 24.5C15.2579 24.5 15.5105 24.4321 15.7346 24.3042C15.9584 24.1764 16.1456 23.9935 16.2812 23.7743L15.8559 23.5113L16.2812 23.7743L20.4526 17.0305C21.2624 15.7214 21.6187 14.162 21.4651 12.613C21.3116 11.064 20.6568 9.61347 19.6052 8.50595Z" stroke="#93959C" />
                            <circle cx="15" cy="13" r="2.5" stroke="#93959C" />
                        </svg>
                        <img v-else-if="item.location" :src="item.pictureUrl" width="40" height="40" style="border-radius: 50%; overflow: hidden;" @error="imgError(item)" />
                    </div>
                    <span  style="font-size: 14px; color: #6C6B6B; ">
                        {{item.dialDT.slice(11,16)}}
                    </span>

                    <!--<div v-if="item.upDT != null">
                        <img width="36" height="36"  src="../assets/Player.png" />
                    </div>-->
                </div>
            </div>
        </div>
        <div v-else class="CallInHistoryWrap">
            <div class="md-text">
                今日無通話紀錄
            </div>
        </div>
    </div>

</template>
<script>
    const GetCallInHistoyrUrl = "GetDataApi/GetCallinHistory"
    import CallinHistory from "../JsonData/CallinHistory"

    export default {
        data() {
            return {
                CallInHistory: {
                    item: [],
                    status: ''
                },
            }
        },
        watch: {
            $route(to, from) {
                this.getCallInHistory()

            },
        },
        mounted() {
            this.getCallInHistory()

        },
        computed: {
            Today: function () {
                const date = new Date()
                return date.toLocaleDateString()
            }
        },
        methods: {
            //取得通話歷史紀錄
            getCallInHistory() {
                let EndDate = new Date(new Date().setDate(new Date().getDate() + 1)).toLocaleDateString();
                let StartDate = new Date().toLocaleDateString();
                let myServicePhone = this.$route.params.ServicePhone
                this.CallInHistory.item = CallinHistory
            },
            imgError(item) {
                item.pictureUrl = require('../assets/DefaultPic.png')
            },
        }
    }
</script>
<style>
    #CallInHistoryv2 {
        padding: 26px 30px;
       
    }

        #CallInHistoryv2 .Penaltitle {
            color: #FCFCFC;
            margin-bottom: 20px;
        }

        #CallInHistoryv2 .md-text {
            color: #93959C;
        }

        #CallInHistoryv2 .CallInHistoryWrap::-webkit-scrollbar {
            width: 0;
            height: 6px;
            background-color: #23262b;
            cursor: pointer;
        }

        #CallInHistoryv2 .CallInHistoryWrap::-webkit-scrollbar-thumb {
            width: 0;
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 0px white;
            background-color: #23262b;
        }


        #CallInHistoryv2 .CallInHistoryWrap:hover::-webkit-scrollbar {
            width: 0;
            height: 6px;
            background-color: #23262b;
            cursor: pointer;
        }

        #CallInHistoryv2 .CallInHistoryWrap:hover::-webkit-scrollbar-thumb {
            width: 0;
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
            background-color: #23262b;
        }

        #CallInHistoryv2 .more {
            color: #0090FF;
            font-size: 18px;
        }

        #CallInHistoryv2 .CallInHistoryWrap {
            margin-top: 20px;
            height: calc(100vh - 300px);
            overflow-y: scroll;
        }

            #CallInHistoryv2 .CallInHistoryWrap .CallInHistoryItem {
                background: #1D1E24;
                border-radius: 20px;
                width: 100%;
                padding: 14px 21px;
                margin-bottom: 15px;
            }

                #CallInHistoryv2 .CallInHistoryWrap .CallInHistoryItem .statusIcon {
                    width: 40px;
                    height: 40px;
                    background: #93959c24;
                    border-radius: 10px;
                    margin-right: 26px;
                }

                #CallInHistoryv2 .CallInHistoryWrap .CallInHistoryItem .AgentUp {
                    border-radius: 50%;
                    overflow: hidden;
                    left: 32px;
                    bottom: -2px;
                }
</style>